export default __webpack_public_path__ + "static/N0002-b64219cf99f1077885ea7517eea230e0.png";